import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Injectable,OnChanges,Renderer2, RendererFactory2, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as mapboxgl from 'mapbox-gl';
import { DashboardpenelComponent } from 'src/app/dashboard/dashboardpenel/dashboardpenel.component';
import { environment } from '../../../environments/environment';
import {areas,areaBounds,areaCentroids} from "../geojson/index";
import { UserService } from './user.service';
import {DynamicComponentService} from "./dynamic-component.service";
import { Router } from '@angular/router';
// import Point from 'ol/geom/Point';
import _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class MapquoteService {
  map: mapboxgl.Map;
  style = 'mapbox://styles/eedelstein/cixqym350000b2rn847shrpr5';
  lat = 45.899977;
  lng = 6.172652;
  zoom = 1;
  maploaded:boolean = false;
  private renderer: Renderer2

  constructor(rendererFactory: RendererFactory2,private number:DecimalPipe,private currency:CurrencyPipe,
    private user:UserService,
    private dialog: MatDialog,
    private dynamicComponentService:DynamicComponentService,
    private router:Router
    ) {
    (mapboxgl as any).accessToken = environment.mapbox.accessToken;
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  ngOnChanges(changes: SimpleChanges){
    
  }
  buildMap = (mapDiv='map', code='') => {

    this.map = new mapboxgl.Map({
      accessToken: environment.mapbox.accessToken,
      container: mapDiv,
      style: this.style,
      zoom: this.zoom,
      center: [this.lng, this.lat]
    })
    this.dropBounds();
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.on("load",(data)=>{        
      const pointer = this.renderer.createElement('span');
      this.renderer.addClass(pointer,"iwg-dashboard-panel-pointer");
      const marker = this.renderer.createElement('span');
      this.renderer.appendChild(pointer,marker);
     
      this.map.getContainer().appendChild(pointer);
      this.map.addSource('areas', {
        type: 'geojson',
        data: areas
    });


    this.map.addLayer({
        id: 'areas-borders',
        type: 'line',
        source: 'areas',
        layout: {
            'line-join': 'round',
            'line-cap': 'round'
        },
        paint: {
            'line-color': '#333333',
            'line-width': 2
        },
        filter: ['!has', 'code']
    });

    this.map.addLayer({
        id: 'areas',
        type: 'fill',
        source: 'areas',
        paint: {
            'fill-color': '#33a3be',
            'fill-opacity': .7
        },
        filter: ['!has', 'code']
    });
    if(code) {
      this.setData(code)
    }
    });
  }
  setData(code){
    
    if (!code) {
      this.dropBounds();
      return false;
  }
  
  // let interval = setInterval(()=>{
    let countryBounds = this.getFeatureByProperties(areaBounds, {code});
  //let countryBounds = _.property('geometry.coordinates')(this.getFeatureByProperties(areaBounds, {code}));
  //let countryCentroid = _.property('geometry.coordinates')(this.getFeatureByProperties(areaCentroids, {code}));

      if (!countryBounds?.geometry?.coordinates) {
      this.dropBounds();
      // clearInterval(interval);
      return false;
  }

let bounds = countryBounds?.geometry?.coordinates.reduce(function (bounds, coord) {
    return bounds.extend(coord);
    }, new mapboxgl.LngLatBounds());
 this.map.setFilter('areas-borders', ['==', 'code', code]);
 this.map.setFilter('areas', ['==', 'code', code]);

  //this.map.setCenter(countryCentroid);
  this.map.fitBounds(bounds);
  // clearInterval(interval);
  // },10);
  }
  onMapLoaded(event): void {
    event.map.resize();
  }
 
getFeatureByProperties(collection, properties) {
  let feature = collection.features.find(i=>i.properties.code == properties.code);

  if (!feature) {     
      //this._$log.warn(`Can't find feature properties: ${JSON.stringify(properties)}`);
  }
  return feature;
}
//   dropBounds() {
//     this.map.setMaxBounds([[-180, -84], [180, 84]]);
//     this.map.fitBounds([[-180, -84], [180, 84]], {
//         animate: false
//     });
//  }
 dropBounds() {
  this.map.fitBounds([[-180, -84], [180, 84]]);
  // this._$timeout()
  // .then(() => this.mapPromise)
  // .then(() => {

  // });
  
  // this.map.setFilter('areas-borders', ['!has', 'code']);
  // this.map.setFilter('areas', ['!has', 'code']);

}

}
